import { Dialog, useMediaQuery } from "@mui/material";
import React, { useRef } from "react";
import { useSelector } from "react-redux";
import {
  affiliatesJoinPopupOpenSelector,
  setAffiliatesJoinPopupClose,
} from "../../../../store/features/affiliatesSlice";
import { useAppDispatch } from "../../../../store/store";
import JoinAffiliatesImg1 from "../../../../assets/affiliates/joinPopupImg1.png";
import JoinAffiliatesImg2 from "../../../../assets/affiliates/joinPopupImg2.png";
import JoinAffiliatesImg3 from "../../../../assets/affiliates/joinPopupImg3.png";
import WhiteCross from "../../../../assets/affiliates/whiteCross.svg";
import BlackCross from "../../../../assets/affiliates/blackCross.svg";

import { Swiper, SwiperRef, SwiperSlide } from "swiper/react";
import { Pagination, EffectFade } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import { useTranslation } from "react-i18next";
import { AffiliatesJoinIntroStep } from "./steps/AffiliatesJoinIntroStep";
import { useLanguageTheme } from "../../../../hooks/useLanguageTheme";
import { AffiliatesJoinTermsStep } from "./steps/AffiliatesJoinTermsStep";
import { AffiliatesJoinWelcomeOnBoardStep } from "./steps/AffiliatesJoinWelcomeOnBoardStep";
import { useUserProfile } from "../../../../hooks/useUserProfile";

export const AffiliatesJoinPopup = () => {
  const { i18n } = useTranslation(["affiliates"]);
  const isRTL = i18n.dir() === "rtl";

  const langTheme = useLanguageTheme();
  const dispatch = useAppDispatch();
  const affiliatesJoinPopupOpen = useSelector(affiliatesJoinPopupOpenSelector);
  const isMobile = useMediaQuery("(max-width: 980px)");

  const { refetch } = useUserProfile();

  const handleCloseAffiliatesJoinPopup = () => {
    dispatch(setAffiliatesJoinPopupClose());
    if (refetch) {
      refetch();
    }
  };

  const swiperRef = useRef<SwiperRef>(null);

  const handleGoToNextSlide = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const handleGoToPrevSlide = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  return (
    <Dialog
      open={affiliatesJoinPopupOpen}
      onClose={handleCloseAffiliatesJoinPopup}
      sx={{
        ".MuiPaper-root": {
          maxWidth: "1250px",
          height: "100%",
          borderRadius: "20px",
          margin: "20px",
        },
      }}
    >
      <div
        style={{
          position: "relative",
          height: "100%",
          fontFamily: langTheme.mainFont(),
        }}
      >
        <Swiper
          dir={i18n.dir()}
          ref={swiperRef}
          modules={[Pagination, EffectFade]}
          pagination={{
            el: `.join-affiliates-pagination`,
            clickable: false,
          }}
          allowTouchMove={false}
          speed={500}
          effect="fade"
          fadeEffect={{
            crossFade: true,
          }}
          onBeforeInit={(swiper: any) => {
            swiper.params.pagination.el = document.querySelector(
              `.join-affiliates-pagination`
            );
          }}
          style={{
            borderRadius: "20px",
            maxWidth: "100%",
            height: "100%",
          }}
        >
          <SwiperSlide>
            <div
              className="join-affiliates-popup-wrapper"
              style={{
                direction: i18n.dir(),
              }}
            >
              <AffiliatesJoinIntroStep
                handleGoToNextSlide={handleGoToNextSlide}
              />
              {!isMobile && (
                <div
                  className="join-affiliates-img-wrapper"
                  style={{
                    background: `url(${JoinAffiliatesImg1}) center center / cover no-repeat`,
                  }}
                ></div>
              )}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="join-affiliates-popup-wrapper"
              style={{
                direction: i18n.dir(),
              }}
            >
              <AffiliatesJoinTermsStep
                handleGoToNextSlide={handleGoToNextSlide}
                handleGoToPrevSlide={handleGoToPrevSlide}
              />

              {!isMobile && (
                <div
                  className="join-affiliates-img-wrapper"
                  style={{
                    background: `url(${JoinAffiliatesImg2}) center center / cover no-repeat`,
                  }}
                ></div>
              )}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div
              className="join-affiliates-popup-wrapper"
              style={{
                direction: i18n.dir(),
              }}
            >
              <AffiliatesJoinWelcomeOnBoardStep
                handleGoToPrevSlide={handleGoToPrevSlide}
              />

              <div
                className="join-affiliates-img-wrapper"
                style={{
                  background: `url(${JoinAffiliatesImg3}) center center / cover no-repeat`,
                }}
              ></div>
            </div>
          </SwiperSlide>
        </Swiper>

        <div
          className={
            isMobile ? `close-popup-wrapper-mobile` : `close-popup-wrapper`
          }
          style={{ [i18n.dir() === "rtl" ? "left" : "right"]: "30px" }}
          onClick={handleCloseAffiliatesJoinPopup}
        >
          <img src={isMobile ? BlackCross : WhiteCross} alt="Cross" />
        </div>

        <div
          className={`join-affiliates-pagination`}
          style={{
            bottom: "25px",
            width: "fit-content",
            zIndex: "10",
            left: isRTL ? "25%" : "75%",
            direction: i18n.dir(),
          }}
        />
      </div>
    </Dialog>
  );
};
